/**
 * Register the XYZPLUS service worker.
 *
 * Why a separate file (not inline in index.js)?
 *   - The registration call is async and we want it OFF the critical path
 *     of the initial render. It runs after `window.load`.
 *   - Keeps index.js focused on React boot.
 *
 * Also exposes purge helpers used by admin pages after edits.
 */

const SW_URL = "/sw.js";

export function registerServiceWorker() {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;
  // Defer registration until after the page is fully loaded so we don't
  // compete with the LCP image / main bundle parse on cold load.
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register(SW_URL)
      .then((reg) => {
        // Surface the registration so admin pages can post messages to it.
        window.__xyzSWReg = reg;
      })
      .catch(() => { /* SW unsupported / file 404 — degrade silently */ });
  });
}

function postToSW(message) {
  if (typeof navigator === "undefined" || !navigator.serviceWorker || !navigator.serviceWorker.controller) return;
  try {
    navigator.serviceWorker.controller.postMessage(message);
  } catch { /* noop */ }
}

// Admin-side cache invalidation hooks. After a successful CMS edit, the
// admin page calls these so the next public visit gets fresh data even
// though the SW would normally serve stale-while-revalidate.
export function purgeSwMetaCache() { postToSW({ type: "PURGE_META" }); }
export function purgeSwImgCache() { postToSW({ type: "PURGE_IMG" }); }
export function purgeSwAll() { postToSW({ type: "PURGE_ALL" }); }

// Expose a debugging escape hatch on window for QA / testing.
if (typeof window !== "undefined") {
  window.__purgeXYZCache = purgeSwAll;
}
